export enum EmailVerificationToastItem {
  SEND_ERROR = 'send-email-error',
  SEND_SUCCESS = 'send-email-success',
}

export enum EmailVerificationSource {
  DASHBOARD = 'dashboard',
}
